module.exports = "<p>\r\n  view-blog works!\r\n</p>\r\n"